import ConsumerId from './containers/consumer/consumerId';
import Dashboard from './containers/dashboard';
import Application from './containers/application';
import DealerList from './containers/dealerList';
import Notification from './containers/notification';
import Eligiblity from './containers/eligibility';
import Login from './containers/login';
import Verify from './components/application/consumer/kyc/verify';
import SerialNumberValidation from './components/application/scanner/SerialNumberValidation';
import emiCalculator from './containers/emiCalculator';

import VerifyScreen from './components/application/consumer/serial-number-validation/verify';
import schemeChart from './components/application/notification/schemeChart';
import Cancel from './components/application/application/cancel';
import CustomerDoc from './components/application/consumer/documents/CustomerDoc';
import ImeiScanner from './components/application/scanner/ImeiScanner';
import Leads from './containers/leads/Leads';
import Details from './containers/leads/Details';
import Faq from './components/application/Faq/Faq';

export const publicRoutes = [
  { path: '/login', exact: true, component: Login },
  { path: '/*', exact: false, component: Login },
  { path: '/verify', exact: true, component: Verify },
  { path: '/scanners', exact: true, component: SerialNumberValidation },
  { path: '/emicalculator', exact: true, component: emiCalculator },
  { path: '/screenbros', exact: true, component: VerifyScreen },
  { path: '/documents', exact: true, component: CustomerDoc },
  { path: '/imei', exact: true, component: ImeiScanner },
];

export const dashboardRoutes = [
  { path: '/dashboard', exact: true, component: Dashboard },
  { path: '/application', exact: true, component: Application },
  { path: '/leads', exact: true, component: Leads },
  { path: '/dealerList', exact: true, component: DealerList },
  { path: '/notification', exact: true, component: Notification },
  { path: '/eligiblity', exact: true, component: Eligiblity },
  { path: '/consumerId', exact: true, component: ConsumerId },
  { path: '/schemechart', exact: true, component: schemeChart },
  { path: '/details', exact: true, component: Cancel },
  { path: '/leaddetails', exact: true, component: Details },
  { path: '/faq', exact: true, component: Faq },
];